export const ASSET_ACTIVITY_STATUS_TYPES_DIC = {
  RECEIVED: "received",
  CANCELLED: "cancelled",
  SENT: "sent",
}

export const ASSET_ACTIVITY_STATUS_OPTIONS = {
  [ASSET_ACTIVITY_STATUS_TYPES_DIC.RECEIVED]: {
    label: "RECIBIDO",
    className: "asset-activity-status received-style"
  },
  [ASSET_ACTIVITY_STATUS_TYPES_DIC.CANCELLED]: {
    label: "CANCELADO",
    className: "asset-activity-status cancelled-style"
  },
  [ASSET_ACTIVITY_STATUS_TYPES_DIC.SENT]: {
    label: "ENVIADO",
    className: "asset-activity-status sent-style"
  }
}

export const FILTER_KEYS = {
  USER: 'NOMBRE DE USUARIO',
  CLIENT: 'NOMBRE DE CLIENTE',
  STATUS: 'ESTADO',
}

export const TYPE_STATUS_ASSET_ACTIVITIES = Object.values(ASSET_ACTIVITY_STATUS_OPTIONS).map(opt => opt.label)
// ["RECIBIDO", "CANCELADO", "ENVIADO"]

export const LABEL_TO_STATUS_VALUE = Object.fromEntries(
  Object.entries(ASSET_ACTIVITY_STATUS_OPTIONS).map(([value, obj]) => [obj.label, value])
)
